import { render, staticRenderFns } from "./FaltaJustificadaDetailDialog.vue?vue&type=template&id=7b97567f"
import script from "./FaltaJustificadaDetailDialog.vue?vue&type=script&lang=js"
export * from "./FaltaJustificadaDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports